/* eslint-disable no-unused-vars */
import { useRef, useEffect, useState } from 'react';
import { createContext } from 'react';
import PropTypes from 'prop-types';

// project import
import ReconnectingWebSocket from 'reconnecting-websocket';
import useAuth from 'hooks/useAuth';

const BASE_URL_WS = process.env.REACT_APP_API_WS;
const MAX_CONNECTION_RETRIES = 10;
const FORBIDDEN_WS_STATUS = 1008;

const initialState = {
  isReady: false,
  wsMessage: '',
  sendWsMessage: null,
  resetWsMessage: null,
  reconnectWs: null
};

// ==============================|| WEBSOCKET CONTEXT & PROVIDER ||============================== //

const WebsocketContext = createContext(initialState);

function WebsocketProvider({ children }) {
  const [wsMessage, setWsMessage] = useState(null);
  const { logout } = useAuth();
  const [isReady, setIsReady] = useState(null);
  const ws = useRef(null);
  const { token } = useAuth();

  useEffect(() => {
    if (!token) return;

    const socket = new ReconnectingWebSocket(BASE_URL_WS, token, { maxRetries: MAX_CONNECTION_RETRIES });

    socket.binaryType = 'arraybuffer';
    socket.onclose = (event) => {
      console.info('Websocket closed (CONTEXT)', event);

      if (event.code === FORBIDDEN_WS_STATUS) {
        // logout();
      }
    };
    socket.onopen = () => {
      console.info('Websocket connection open (CONTEXT) ...');
      setIsReady(true);
    };
    socket.onmessage = (event) => setWsMessage(event.data);

    ws.current = socket;

    return () => {
      setWsMessage(null);
      socket.close();
    };
  }, [token]);

  const wsActions = {
    isReady,
    wsMessage,
    sendWsMessage: (message) => ws.current?.send(message),
    resetWsMessage: () => setWsMessage(null),
    reconnectWs: () => ws.current?.reconnect()
  };

  return <WebsocketContext.Provider value={wsActions}>{children}</WebsocketContext.Provider>;
}

WebsocketProvider.propTypes = {
  children: PropTypes.node
};

export { WebsocketProvider, WebsocketContext };
